import React from 'react';
import { motion } from 'framer-motion';
import { Sparkles, ArrowRight, Check } from 'lucide-react';
export function Pricing() {
  return <section id="oferta" className="py-24 bg-[#292524] text-white relative overflow-hidden" data-id="element-87">
      {/* Decorative background elements */}
      <div className="absolute top-0 left-0 w-full h-full overflow-hidden opacity-10 pointer-events-none" data-id="element-88">
        <div className="absolute -top-24 -left-24 w-96 h-96 rounded-full bg-[#C5A059] blur-3xl" data-id="element-89"></div>
        <div className="absolute bottom-0 right-0 w-96 h-96 rounded-full bg-[#DFB76C] blur-3xl" data-id="element-90"></div>
      </div>

      <div className="max-w-4xl mx-auto px-6 relative z-10 text-center" data-id="element-91">
        <motion.div initial={{
        opacity: 0,
        scale: 0.9
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="bg-white/5 backdrop-blur-lg border border-[#C5A059]/30 rounded-3xl p-8 md:p-12 shadow-2xl max-w-2xl mx-auto" data-id="element-92">
          <h2 className="text-2xl md:text-3xl font-serif text-[#DFB76C] mb-8" data-id="element-93">
            RESUMEN DE TU TRANSFORMACIÓN
          </h2>

          <div className="mb-8 rounded-2xl overflow-hidden border border-white/10 shadow-2xl relative group" data-id="element-94">
            <div className="absolute inset-0 bg-gradient-to-t from-black/40 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300 z-10" data-id="element-95"></div>
            <img src="https://cdn.magicpatterns.com/uploads/61sVLyx5mtrXVR2J27mBqs/Imagen_preincipal.png" alt="Kit Completo El Código Invisible del Dinero" className="w-full h-auto object-cover transform group-hover:scale-105 transition-transform duration-700" data-id="element-96" />
          </div>

          <div className="space-y-5 mb-8 text-left bg-black/20 p-6 md:p-8 rounded-2xl border border-white/10" data-id="element-97">
            {/* Ebook */}
            <div className="flex justify-between items-center border-b border-white/10 pb-5" data-id="element-98">
              <div className="flex items-center gap-4" data-id="element-99">
                <div className="w-14 h-14 md:w-16 md:h-16 shrink-0 rounded-lg overflow-hidden border border-white/10 bg-black/40" data-id="element-100">
                  <img src="https://cdn.magicpatterns.com/uploads/iWimrgztMff35AKnRwAAP8/Ebook_inicial.png" alt="Ebook" className="w-full h-full object-cover" data-id="element-101" />
                </div>
                <div data-id="element-102">
                  <h4 className="text-stone-200 font-bold text-sm md:text-base" data-id="element-103">
                    Ebook: El Código Invisible
                  </h4>
                  <p className="text-stone-400 text-xs mt-1 max-w-[200px] md:max-w-[250px] leading-snug" data-id="element-104">
                    El manual paso a paso para reprogramar tu termostato
                    financiero.
                  </p>
                </div>
              </div>
              <div className="text-right shrink-0 pl-2" data-id="element-105">
                <span className="text-stone-500 line-through text-xs block" data-id="element-106">
                  $27.00 USD
                </span>
                <span className="text-[#DFB76C] font-bold text-sm" data-id="element-107">
                  INCLUIDO
                </span>
              </div>
            </div>

            {/* Bono 1 */}
            <div className="flex justify-between items-center border-b border-white/10 pb-5" data-id="element-108">
              <div className="flex items-center gap-4" data-id="element-109">
                <div className="w-14 h-14 md:w-16 md:h-16 shrink-0 rounded-lg overflow-hidden border border-white/10 bg-black/40" data-id="element-110">
                  <img src="https://cdn.magicpatterns.com/uploads/tHaUo3Q2fteRSt3z8qZjaH/Bonos_1.png" alt="Bono 1" className="w-full h-full object-cover" data-id="element-111" />
                </div>
                <div data-id="element-112">
                  <h4 className="text-stone-200 font-bold text-sm md:text-base" data-id="element-113">
                    Bono 1: Guionismo de Realidades
                  </h4>
                  <p className="text-stone-400 text-xs mt-1 max-w-[200px] md:max-w-[250px] leading-snug" data-id="element-114">
                    Escribe y manifiesta tu nueva vida de abundancia con
                    precisión.
                  </p>
                </div>
              </div>
              <div className="text-right shrink-0 pl-2" data-id="element-115">
                <span className="text-stone-500 line-through text-xs block" data-id="element-116">
                  $15.00 USD
                </span>
                <span className="text-green-400 font-bold text-sm" data-id="element-117">GRATIS</span>
              </div>
            </div>

            {/* Bono 2 */}
            <div className="flex justify-between items-center border-b border-white/10 pb-5" data-id="element-118">
              <div className="flex items-center gap-4" data-id="element-119">
                <div className="w-14 h-14 md:w-16 md:h-16 shrink-0 rounded-lg overflow-hidden border border-white/10 bg-black/40" data-id="element-120">
                  <img src="https://cdn.magicpatterns.com/uploads/qBT1S5rWH7vN2jdgswgyYM/Bonos_2.png" alt="Bono 2" className="w-full h-full object-cover" data-id="element-121" />
                </div>
                <div data-id="element-122">
                  <h4 className="text-stone-200 font-bold text-sm md:text-base" data-id="element-123">
                    Bono 2: Mapa de los 5 Canales
                  </h4>
                  <p className="text-stone-400 text-xs mt-1 max-w-[200px] md:max-w-[250px] leading-snug" data-id="element-124">
                    Diversifica tus ingresos alineada con tu energía femenina.
                  </p>
                </div>
              </div>
              <div className="text-right shrink-0 pl-2" data-id="element-125">
                <span className="text-stone-500 line-through text-xs block" data-id="element-126">
                  $19.00 USD
                </span>
                <span className="text-green-400 font-bold text-sm" data-id="element-127">GRATIS</span>
              </div>
            </div>

            {/* Bono 3 */}
            <div className="flex justify-between items-center pt-1" data-id="element-128">
              <div className="flex items-center gap-4" data-id="element-129">
                <div className="w-14 h-14 md:w-16 md:h-16 shrink-0 rounded-lg overflow-hidden border border-white/10 bg-black/40" data-id="element-130">
                  <img src="https://cdn.magicpatterns.com/uploads/2o2rABF6mjBvDBGuDRLwtk/Bonos_3.png" alt="Bono 3" className="w-full h-full object-cover" data-id="element-131" />
                </div>
                <div data-id="element-132">
                  <h4 className="text-stone-200 font-bold text-sm md:text-base" data-id="element-133">
                    Bono 3: Billetera Magnética
                  </h4>
                  <p className="text-stone-400 text-xs mt-1 max-w-[200px] md:max-w-[250px] leading-snug" data-id="element-134">
                    Checklist para limpiar energética y físicamente tus
                    finanzas.
                  </p>
                </div>
              </div>
              <div className="text-right shrink-0 pl-2" data-id="element-135">
                <span className="text-stone-500 line-through text-xs block" data-id="element-136">
                  $12.00 USD
                </span>
                <span className="text-green-400 font-bold text-sm" data-id="element-137">GRATIS</span>
              </div>
            </div>
          </div>

          <div className="flex flex-col items-center justify-center mb-10" data-id="element-138">
            <p className="text-stone-400 text-lg font-medium mb-1" data-id="element-139">
              Valor Total Real:
            </p>
            <p className="text-red-400/90 line-through decoration-red-500/60 text-5xl md:text-6xl font-bold mb-6" data-id="element-140">
              $73.00 USD
            </p>

            <div className="bg-[#C5A059]/10 border border-[#C5A059]/30 text-[#DFB76C] px-6 py-2 rounded-full text-sm md:text-base font-bold uppercase tracking-widest mb-4 shadow-[0_0_15px_rgba(197,160,89,0.2)]" data-id="element-141">
              Hoy te llevas todo por solo
            </div>

            <div className="flex items-baseline gap-2" data-id="element-142">
              <span className="text-7xl md:text-8xl font-bold text-white tracking-tighter drop-shadow-[0_0_25px_rgba(197,160,89,0.4)]" data-id="element-143">
                $6.39
              </span>
              <span className="text-2xl text-[#DFB76C] font-medium" data-id="element-144">USD</span>
            </div>
          </div>

          <motion.a href="https://pay.hotmart.com/L105538443T" target="_blank" rel="noopener noreferrer" onClick={() => {
          if ((window as any).fbq) {
            ;
            (window as any).fbq('track', 'InitiateCheckout');
          }
        }} whileHover={{
          scale: 1.02
        }} whileTap={{
          scale: 0.98
        }} className="group relative w-full md:w-auto inline-flex items-center justify-center gap-3 px-8 py-5 text-lg font-bold text-stone-900 rounded-full overflow-hidden shadow-[0_0_40px_rgba(197,160,89,0.3)] transition-all hover:shadow-[0_0_60px_rgba(197,160,89,0.5)]" data-id="element-145">
            <div className="absolute inset-0 gold-gradient" data-id="element-146"></div>
            <div className="absolute inset-0 bg-white/20 opacity-0 group-hover:opacity-100 transition-opacity" data-id="element-147"></div>
            <span className="relative flex items-center gap-2" data-id="element-148">
              SÍ, QUIERO EMPEZAR MI TRANSFORMACIÓN
              <ArrowRight className="w-5 h-5 group-hover:translate-x-1 transition-transform" data-id="element-149" />
            </span>
          </motion.a>

          <p className="mt-6 text-sm text-stone-400 flex items-center justify-center gap-2" data-id="element-150">
            <Sparkles className="w-4 h-4 text-[#DFB76C]" data-id="element-151" />
            Haz clic para activar tu flujo de abundancia hoy mismo.
          </p>
        </motion.div>
      </div>
    </section>;
}